<template>
  <ul class="common-wrapper flat-job-list" :class="enableSelect && 'enable-select'">
    <li
      v-for="(job, index) in data"
      class="job-info-wrapper"
      :key="index"
    >
      <div class="job-checkbox-container">
        <van-checkbox v-model="selected[job.pk]" class="job-checkbox"></van-checkbox>
      </div>
      <div class="job-coloum-info-container job-info" @click="jobApply(job)">
        <div class="job-title" :class="showReferral(job) && 'has-referral-title'">
          <span v-if="job.hot" class="hot_job_icon"></span>
          <a class="job-name ellipsis">
            {{ job.title }}
          </a>
        </div>
        <div v-if="showReferral(job)" class="job-referral-icon">
          <i class="iconfont iconhongbao1"></i>
        </div>
        <div class="job-company-container">
          <div
            class="job-company"
            :class="company.id || list_show_company_name ? 'job-company-groupm' : ''">
            {{ jobCompanyName(job) }}
          </div>
          <span v-if="showCompanyNameSpan(job)" class="job-company-name">{{ job.company.name }}</span>
          <span class="create-time">{{ job.updated_time }}</span>
        </div>
        <div class="detail-info">
          <span v-if="showSalary" class="salary">
            {{ job.salary }}
          </span>
          <span v-if="job.job_visibility === 'E'" class="work-time">
            {{ $t('companyJobList.externalJob') }}
          </span>
          <span v-else-if="job.job_visibility === 'I'" class="work-time">
            {{ $t('companyJobList.internalJob') }}
          </span>
          <span class="role-type">{{ job.role_type }}</span>
          <span class="distance">
            {{ job.distance | formatDistance }}{{ job.distance && 'km'}}
          </span>
        </div>
      </div>
    </li>
  </ul>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  props: {
    data: {
      type: Array,
      required: true
    },
    company: {
      type: Object,
      required: true
    },
    showSalary: {
      type: Boolean
    },
    enableSelect: {
      type: Boolean,
      default: false
    },
    selected: {
      type: Object,
      default: null
    }
  },
  data () {
    return {

    }
  },
  computed: {
    list_show_company_name () {
      const MOBILE_WEB_MORE_JOBS_SHOW_COMPANY_NAME = [4474, 6703, 7061, 6958, 7086, 7087, 7084, 7088, 7085]
      const SHOW_COMPANY_NAME_IN_JOB_LIST_ROOT_ID = [2435, 6240, 7812]
      if (MOBILE_WEB_MORE_JOBS_SHOW_COMPANY_NAME.indexOf(this.company.id) > -1) {
        return true
      }
      const rootCompanyId = this.company.root_company && this.company.root_company.id
      if (rootCompanyId && SHOW_COMPANY_NAME_IN_JOB_LIST_ROOT_ID.indexOf(rootCompanyId) > -1) {
        return true
      }
      return false
    }
  },
  created () {

  },
  methods: {
    ...mapActions('referral', ['getJobReferralUrl']),
    async jobApply (job) {
      const listReferralId = this.$route.query.lReferId
      const jobId = job.pk
      let url = ''
      if (listReferralId) {
        url = await this.getJobReferralUrl({ listReferralId, jobId })
      }
      if (!url) {
        const id = job.short_unique_id
        url = `/job-description/${id}/?company_id=${this.company.id}`
      }
      const query = this.$route.query
      const pathReg = /^\/msdchina.*/
      if (pathReg.test(this.$route.path)) {
        query.backUrl = this.$route.path
      }
      this.$router.push({ path: url, query: query, hash: this.$route.hash })
    },
    showReferral (job) {
      return job.referral_settings && job.referral_settings.to_show_referral && job.job_visibility !== 'I'
    },
    showCompanyNameSpan (job) {
      if (window.location.href.indexOf('/accor/') === -1) {
        if (this.list_show_company_name) {
          return true
        } else {
          if (job.company.show_company_name_in_job_list) {
            return true
          }
        }
      }
      return false
    },
    jobCompanyName (job) {
      if (window.location.href.indexOf('/accor/') !== -1) {
        return job.company.name
      } else {
        if (job.cities.length > 1) {
          return this.$t('companyJobList.multiLocations')
        } else {
          if (job.city_name) {
            return job.city_name
          } else {
            return job.cities.join(' ')
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.flat-job-list {
  margin: 0 10px;
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
  &.enable-select {
    .job-info-wrapper {
      .job-checkbox-container {
        flex-basis: 25px;
      }
    }
  }

  .job-info-wrapper {
    display: flex;
    align-items: center;
    overflow: hidden;

    .job-checkbox-container {
      flex-shrink: 0;
      flex-grow: 0;
      flex-basis: 0;
      transition: flex-basis .3s;
      overflow: hidden;

      ::v-deep {
        .van-checkbox__icon--checked {
          .van-icon {
            background-color: var(--custom-color);
            border-color: var(--custom-color);
          }
        }
      }
    }

    .job-info {
      flex-shrink: 0;
      flex-grow: 0;
      flex-basis: 100%;
      margin: 0 !important;
      box-sizing: border-box;
      position: relative;

      .job-title {
        line-height: initial;
      }

      .job-referral-icon {
        width: 20px;
        height: 25px;
        text-align: center;
        overflow: hidden;
        color: var(--custom-color, #fd8232);
        position: absolute;
        top: 10px;
        right: 0;

        i {
          font-size: 32px;
          position: absolute;
          top: -4px;
          left: -6px;
        }
      }
    }
  }
}
</style>
